import { TableHead, TableRow } from "@material-ui/core";
import React from "react";
import StyledTableCell from "../../../styles/tableCell";

export default function TableHeadProduct({ isMovile, isAccesory, singleSite }) {
  return (
    <TableHead>
      <TableRow
        style={{
          borderBottom: "0.5px solid gray",
        }}
      >
        <StyledTableCell align="center">Marca</StyledTableCell>
        <StyledTableCell align="center">Modelo</StyledTableCell>
        {singleSite && isMovile && (
          <StyledTableCell align="center">Capacidad</StyledTableCell>
        )}
        {!isMovile && (
          <StyledTableCell align="center">Subcategoría</StyledTableCell>
        )}
        {!isAccesory && <StyledTableCell align="center">Color</StyledTableCell>}
        {(singleSite || isAccesory) && (
          <StyledTableCell align="center">Código de barras</StyledTableCell>
        )}
        {!singleSite && <StyledTableCell align="center">Costo</StyledTableCell>}
        <StyledTableCell align="center">Precio</StyledTableCell>
        <StyledTableCell align="center">Descuento</StyledTableCell>
        {!isAccesory && <StyledTableCell align="center">Lote</StyledTableCell>}
        {!singleSite && (
          <StyledTableCell align="center">En Almacén</StyledTableCell>
        )}
        {!singleSite && (
          <StyledTableCell align="center">En Sucursales</StyledTableCell>
        )}
        {singleSite && (
          <StyledTableCell align="center">Disponibilidad</StyledTableCell>
        )}
      </TableRow>
    </TableHead>
  );
}
